/**
 * Provider registry — maps a {@link SourceSpec.mode} to a concrete
 * {@link SeriesProvider}. Adding a new source (e.g. another OLAP store) is one
 * `register` call and zero panel/renderer changes.
 */

import type { SourceSpec } from '../spec';
import type { SeriesProvider } from './SeriesProvider';

const providers = new Map<SourceSpec['mode'], SeriesProvider>();

export function registerProvider(provider: SeriesProvider): void {
  providers.set(provider.mode, provider);
}

export function getProvider(mode: SourceSpec['mode']): SeriesProvider {
  const p = providers.get(mode);
  if (!p) {
    throw new Error(`No SeriesProvider registered for source mode "${mode}"`);
  }
  return p;
}

export function hasProvider(mode: SourceSpec['mode']): boolean {
  return providers.has(mode);
}
